import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import DescriptionIcon from "@mui/icons-material/Description";
import SourceIcon from "@mui/icons-material/Source";
import UploadIcon from "@mui/icons-material/Upload";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import StorageIcon from "@mui/icons-material/Storage";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

import GSTReonciliation from "./Sales/GST-1_Reconciliation/GSTReconciliation";
import Gst2aReconciliation from "./Purchase/GSTR-2A_Reconciliation/Gst2aReconciliation";
import Gstr2bReconciliation from "./Purchase/GSTR2B_reconciliation/Gstr2bReconciliation";
import Gstr6aReconciliation from "./Purchase/Gstr6a_Reconciliation/Gstr6aReconciliation";
import Gstr8aReconciliation from "./Purchase/Gstr8A_reconciliation/Gstr8aReconciliation";
import Gstr9Reconciliation from "./Purchase/GSTR-9 Reconciliation/Gstr9Reconciliation";
import E_Invoice_Reconcilation from "./Sales/E_Invoice_Reconcilation/e_invoicereconcilation";
import Form26ASTDSRecon from "./Sales/TDSReconciliationSale/26ASrecon";
import Form26ASTCSRecon from "./Sales/TCSReconciliation/recon";
import TdsProvision from "./Purchase/provision/provision";
import AisDashboard from "../AIS/AisDashboard";
import IMSReconcilation from "./Purchase/IMS_Reconcilation/imsReconcilation";
import TDSPayableRecon from "./Purchase/TDS_Payables_Reconciliation/tds_payable_recon";
import IntegratedGSTReconciliation from "./Sales/GSTRecon/GstRecon";
import IMSOutwardReconciliation from "./Sales/IMS_Outward_Recon/ims_outward";
import GSTR_3B_Recon from "./Purchase/GSTR-3B_Reconciliation/GSTR_3B_Recon";

export default function ReconCards() {
  const history = useHistory();
  const location = useLocation();

  const [sitemapData, setSitemapData] = useState(null);

  useEffect(() => {
    const storedSitemap = localStorage.getItem("sitemap");
    if (storedSitemap) {
      try {
        const parsed = JSON.parse(storedSitemap);
        setSitemapData(parsed);
      } catch (e) {
        console.error("Failed to parse sitemap from localStorage", e);
        setSitemapData(null);
      }
    }
  }, []);

  const salesAccess = sitemapData?.["ARC RECONCILLIATION"]?.SALES || [];
  const purchaseAccess = sitemapData?.["ARC RECONCILLIATION"]?.PURCHASE || [];
  const allThreeReconAvailable =
    salesAccess.includes("GSTR1-RECONCILLATION") ||
    purchaseAccess.includes("GSTR2A-RECONCILLATION") ||
    purchaseAccess.includes("GSTR2B-RECONCILLATION");

  const gstReconOptions = [
    allThreeReconAvailable && {
      label: "GST Recon",
      path: "/IntegratedGSTReconciliation",
      component: IntegratedGSTReconciliation,
    },
    salesAccess.includes("GSTR1-RECONCILLATION") && {
      label: "GSTR-1",
      path: "/GSTReconciliation",
      component: GSTReonciliation,
    },
    purchaseAccess.includes("GSTR2A-RECONCILLATION") && {
      label: "GSTR-2A",
      path: "/Gst2aReconciliation",
      component: Gst2aReconciliation,
    },
    purchaseAccess.includes("GSTR2B-RECONCILLATION") && {
      label: "GSTR-2B",
      path: "/Gstr2bReconciliation",
      component: Gstr2bReconciliation,
    },
    purchaseAccess.includes("GSTR3B") && {
      label: 'GSTR-3B',
      path: '/GSTR_3B_Reconciliation',
      component: GSTR_3B_Recon
    },
    (localStorage.getItem("entity_name") === "6A test" ||
      purchaseAccess.includes("GSTR6A-RECONCILLATION")) && {
      label: "GSTR-6A",
      path: "/Gstr6aReconciliation",
      component: Gstr6aReconciliation,
    },
    purchaseAccess.includes("IMS-RECONCILIATION") && {
      label: "IMS INWARD",
      path: "/IMSReconciliation",
      component: IMSReconcilation,
    },
    salesAccess.includes("IMS OUTWARD RECONCILIATION") && {
      label: "IMS OUTWARD",
      path: "/IMSOutwardReconciliation",
      component: IMSOutwardReconciliation,
    },
    sitemapData?.["GSTR-9 RECONCILIATION"]?.["GSTR-9"]?.includes(
      "GSTR-9 RECONCILIATION",
    ) && {
      label: "GSTR-8A",
      path: "/Gstr8aReconciliation",
      component: Gstr8aReconciliation,
    },
    sitemapData?.["GSTR-9 RECONCILIATION"]?.["GSTR-9"]?.includes(
      "GSTR-9 RECONCILIATION",
    ) && {
      label: "GSTR-9",
      path: "/GSTR_9Reconciliation",
      component: Gstr9Reconciliation,
    },
    salesAccess.includes("E-INVOICE RECONCILIATION") && {
      label: "E-Invoice",
      path: "/e_invoicereconcilation",
      component: E_Invoice_Reconcilation,
    },
  ].filter(Boolean);

  const tdsReconOptions = [
    salesAccess.includes("TDS RECIEVABLE RECON") &&
    localStorage.getItem("show_recon") != "N" && {
      label: "26AS-TDS",
      path: "/26ASRecon",
      component: Form26ASTDSRecon,
    },
    salesAccess.includes("TDS RECIEVABLE RECON") &&
    localStorage.getItem("show_recon") != "N" && {
      label: "26AS-TCS",
      path: "/TCS/Recon/26AS",
      component: Form26ASTCSRecon,
    },
    // Show Provision if 26Q or 27Q is enabled
    (purchaseAccess.includes("26Q FILLING (Form-140)") || purchaseAccess.includes("27Q FILING (Form-144)")) && {
      label: "Provision",
      path: "/TDSProvision",
      component: TdsProvision,
    },
    // Show TDS Payable if 26Q or 27Q is enabled
    (purchaseAccess.includes("26Q FILLING (Form-140)") || purchaseAccess.includes("27Q FILING (Form-144)")) && {
      label: "TDS Payable",
      path: "/Gst2aTdsReconciliation",
      component: TDSPayableRecon,
    },
    purchaseAccess.includes("AIS REPOSITORY") && {
      label: "AIS",
      path: "/AisDashboard",
      component: AisDashboard,
    },
  ].filter(Boolean);

  const activeTab = [...gstReconOptions, ...tdsReconOptions].find(
    (tab) => tab.path === location.pathname,
  );
  const ActiveComponent = activeTab?.component;

  const handleCardClick = (report) => {
    history.push(report.path);
  };

  return (
    <Box
      sx={{
        fontFamily: "'Inter', sans-serif",
        width: "100%",
        minHeight: "100vh",
        background: "linear-gradient(to bottom, #e8eef5 0%, #f5f7fa 100%)",
        p: 0,
      }}
    >
      {ActiveComponent ? (
        <ActiveComponent />
      ) : (
        <>
          <Box
            sx={{
              textAlign: "center",
              pt: 3,
              pb: 0.5,
            }}
          >
            <Box
              sx={{
                fontSize: "38px",
                fontWeight: 900,
                color: "#03406d",
                letterSpacing: "2px",
                fontFamily: '"Dosis", sans-serif',
                textTransform: "uppercase",
              }}
            >
              RECONCILIATION
            </Box>
          </Box>
          {gstReconOptions.length > 0 && tdsReconOptions.length > 0 ? (
            <Box
              sx={{
                display: "flex",
                gap: 3,
                p: 4,
                width: "100%",
              }}
            >
              {/* GST Module */}
              <Box
                sx={{
                  flex: 1,
                  background:
                    "linear-gradient(to bottom, #e3f2fd 0%, #f0f4ff 100%)",
                  borderRadius: "16px",
                  overflow: "hidden",
                  border: "3px solid #03406d",
                  boxShadow: "0 4px 20px rgba(3, 64, 109, 0.15)",
                }}
              >
                <Box
                  sx={{
                    background: "#03406d",
                    p: 2,
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      fontSize: "28px",
                      fontWeight: 700,
                      color: "#ffffff",
                      textAlign: "center",
                      letterSpacing: "1px",
                    }}
                  >
                    GST MODULE
                  </Box>
                </Box>
                <Box sx={{ p: 4, pt: 0 }}>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "repeat(2, 1fr)",
                      gap: 2.5,
                    }}
                  >
                    {gstReconOptions.map((report, index) => (
                      <Box
                        key={index}
                        onClick={() => handleCardClick(report)}
                        sx={{
                          background: "#ffffff",
                          borderRadius: "12px",
                          p: 3,
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                          minHeight: "80px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderLeft: "5px solid #03406d",
                          position: "relative",
                          overflow: "hidden",
                          "&::before": {
                            content: '""',
                            position: "absolute",
                            left: 0,
                            top: 0,
                            height: "100%",
                            width: "5px",
                            background: "#03406d",
                            transition: "width 0.4s ease",
                            zIndex: 0,
                          },
                          "&:hover": {
                            transform: "translateY(-4px)",
                            boxShadow: "0 4px 16px rgba(3, 64, 109, 0.25)",
                            "& > div": {
                              color: "#ffffff",
                            },
                          },
                          "&:hover::before": {
                            width: "100%",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            fontSize: "16px",
                            fontWeight: 600,
                            color: "#212121",
                            textAlign: "center",
                            position: "relative",
                            zIndex: 1,
                            transition: "color 0.3s ease",
                          }}
                        >
                          {report.label}
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>

              {/* TDS Module */}
              <Box
                sx={{
                  flex: 1,
                  background:
                    "linear-gradient(to bottom, #e3f2fd 0%, #f0f4ff 100%)",
                  borderRadius: "16px",
                  overflow: "hidden",
                  border: "3px solid #03406d",
                  boxShadow: "0 4px 20px rgba(3, 64, 109, 0.15)",
                }}
              >
                <Box
                  sx={{
                    background: "#03406d",
                    p: 2,
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      fontSize: "28px",
                      fontWeight: 700,
                      color: "#ffffff",
                      textAlign: "center",
                      letterSpacing: "1px",
                    }}
                  >
                    TDS MODULE
                  </Box>
                </Box>
                <Box sx={{ p: 4, pt: 0 }}>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "repeat(2, 1fr)",
                      gap: 2.5,
                    }}
                  >
                    {tdsReconOptions.map((report, index) => (
                      <Box
                        key={index}
                        onClick={() => handleCardClick(report)}
                        sx={{
                          background: "#ffffff",
                          borderRadius: "12px",
                          p: 3,
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                          minHeight: "80px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderLeft: "5px solid #03406d",
                          position: "relative",
                          overflow: "hidden",
                          "&::before": {
                            content: '""',
                            position: "absolute",
                            left: 0,
                            top: 0,
                            height: "100%",
                            width: "5px",
                            background: "#03406d",
                            transition: "width 0.4s ease",
                            zIndex: 0,
                          },
                          "&:hover": {
                            transform: "translateY(-4px)",
                            boxShadow: "0 4px 16px rgba(3, 64, 109, 0.25)",
                            "& > div": {
                              color: "#ffffff",
                            },
                          },
                          "&:hover::before": {
                            width: "100%",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            fontSize: "16px",
                            fontWeight: 600,
                            color: "#212121",
                            textAlign: "center",
                            position: "relative",
                            zIndex: 1,
                            transition: "color 0.3s ease",
                          }}
                        >
                          {report.label}
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>
            </Box>
          ) : gstReconOptions.length > 0 ? (
            <Box sx={{ p: 4, display: "flex", justifyContent: "center" }}>
              <Box
                sx={{
                  maxWidth: "900px",
                  width: "100%",
                  background:
                    "linear-gradient(to bottom, #e3f2fd 0%, #f0f4ff 100%)",
                  borderRadius: "16px",
                  overflow: "hidden",
                  border: "3px solid #03406d",
                  boxShadow: "0 4px 20px rgba(3, 64, 109, 0.15)",
                }}
              >
                <Box
                  sx={{
                    background: "#03406d",
                    p: 2,
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      fontSize: "28px",
                      fontWeight: 700,
                      color: "#ffffff",
                      textAlign: "center",
                      letterSpacing: "1px",
                    }}
                  >
                    GST MODULE
                  </Box>
                </Box>
                <Box sx={{ p: 4, pt: 0 }}>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "repeat(3, 1fr)",
                      gap: 2.5,
                    }}
                  >
                    {gstReconOptions.map((report, index) => (
                      <Box
                        key={index}
                        onClick={() => handleCardClick(report)}
                        sx={{
                          background: "#ffffff",
                          borderRadius: "12px",
                          p: 3,
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                          minHeight: "80px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderLeft: "5px solid #03406d",
                          position: "relative",
                          overflow: "hidden",
                          "&::before": {
                            content: '""',
                            position: "absolute",
                            left: 0,
                            top: 0,
                            height: "100%",
                            width: "5px",
                            background: "#03406d",
                            transition: "width 0.4s ease",
                            zIndex: 0,
                          },
                          "&:hover": {
                            transform: "translateY(-4px)",
                            boxShadow: "0 4px 16px rgba(3, 64, 109, 0.25)",
                            "& > div": {
                              color: "#ffffff",
                            },
                          },
                          "&:hover::before": {
                            width: "100%",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            fontSize: "16px",
                            fontWeight: 600,
                            color: "#212121",
                            textAlign: "center",
                            position: "relative",
                            zIndex: 1,
                            transition: "color 0.3s ease",
                          }}
                        >
                          {report.label}
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>
            </Box>
          ) : tdsReconOptions.length > 0 ? (
            <Box sx={{ p: 4, display: "flex", justifyContent: "center" }}>
              <Box
                sx={{
                  maxWidth: "900px",
                  width: "100%",
                  background:
                    "linear-gradient(to bottom, #e3f2fd 0%, #f0f4ff 100%)",
                  borderRadius: "16px",
                  overflow: "hidden",
                  border: "3px solid #03406d",
                  boxShadow: "0 4px 20px rgba(3, 64, 109, 0.15)",
                }}
              >
                <Box
                  sx={{
                    background: "#03406d",
                    p: 2,
                    mb: 2,
                  }}
                >
                  <Box
                    sx={{
                      fontSize: "28px",
                      fontWeight: 700,
                      color: "#ffffff",
                      textAlign: "center",
                      letterSpacing: "1px",
                    }}
                  >
                    TDS MODULE
                  </Box>
                </Box>
                <Box sx={{ p: 4, pt: 0 }}>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "repeat(3, 1fr)",
                      gap: 2.5,
                    }}
                  >
                    {tdsReconOptions.map((report, index) => (
                      <Box
                        key={index}
                        onClick={() => handleCardClick(report)}
                        sx={{
                          background: "#ffffff",
                          borderRadius: "12px",
                          p: 3,
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                          minHeight: "80px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderLeft: "5px solid #03406d",
                          position: "relative",
                          overflow: "hidden",
                          "&::before": {
                            content: '""',
                            position: "absolute",
                            left: 0,
                            top: 0,
                            height: "100%",
                            width: "5px",
                            background: "#03406d",
                            transition: "width 0.4s ease",
                            zIndex: 0,
                          },
                          "&:hover": {
                            transform: "translateY(-4px)",
                            boxShadow: "0 4px 16px rgba(3, 64, 109, 0.25)",
                            "& > div": {
                              color: "#ffffff",
                            },
                          },
                          "&:hover::before": {
                            width: "100%",
                          },
                        }}
                      >
                        <Box
                          sx={{
                            fontSize: "16px",
                            fontWeight: 600,
                            color: "#212121",
                            textAlign: "center",
                            position: "relative",
                            zIndex: 1,
                            transition: "color 0.3s ease",
                          }}
                        >
                          {report.label}
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                textAlign: "center",
                mt: 10,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <InfoOutlinedIcon
                sx={{ fontSize: 64, color: "#90a4ae", mb: 2 }}
              />
              <Box sx={{ fontSize: "18px", color: "#607d8b" }}>
                Please activate the Reconciliation Services to access.
              </Box>
            </Box>
          )}
        </>
      )}
    </Box>
  );
}
